import { Injectable } from '@angular/core';
import { SecurityService } from './security.service';

/**
 * Detecta si el JWT está próximo a expirar. La renovación y MFA viven en
 * SecurityService/AuthInterceptor y se rigen por la respuesta del servidor.
 */
@Injectable({
  providedIn: 'root'
})
export class TokenManagerService {
  
  // Buffer de tiempo antes de expiración (en segundos)
  private readonly TOKEN_EXPIRY_BUFFER = 60; // Renovar 60 segundos antes de expirar
  
  constructor(private securityService: SecurityService) {}

  /**
   * Verifica si el JWT está próximo a expirar
   * @returns true si el token expira en menos de TOKEN_EXPIRY_BUFFER segundos
   */
  public isTokenExpiringSoon(): boolean {
    const token = this.securityService.getToken();
    if (!token) {
      return true;
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      const expirationTime = payload.exp;
      const timeUntilExpiry = expirationTime - currentTime;
      const isExpiringSoon = timeUntilExpiry <= this.TOKEN_EXPIRY_BUFFER;

      return isExpiringSoon;
    } catch {
      return true;
    }
  }

}
